import React, { SVGAttributes } from 'react';

type GraphicComponentProps = SVGAttributes<SVGGraphicsElement>;

// Base circle graphic for small circled icons. This circle is centered in a "0 0 14 14" coordinate
// space. The radius accounts for a variety of stroke widths up to 1.2. If needing a higher weight,
// either parameterize the radius or create a new circle for use.
export const IconCircle = ({ strokeWidth = 1 }: GraphicComponentProps) => (
  <circle fill="none" strokeWidth={strokeWidth} cx="7" cy="7" r="6.4" />
);

// Based on "0 0 8 14" coordinate space.
export const Chevron = ({ stroke, strokeWidth }: GraphicComponentProps) => (
  <path
    stroke={stroke}
    strokeWidth={strokeWidth}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M1.4 1.4L7 7L1.4 12.6"
  />
);

// Unclosed circle based on a "0 0 14 14" coordinate space
export const PartialCircle = ({ stroke, strokeWidth = 1, ...props }: GraphicComponentProps) => (
  <path
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...props}
    strokeLinecap="round"
    fill="none"
    d="M8.15 0.7a6.4 6.4 0 1 0 5.2 5.5"
  />
);

export const Thumb = ({ stroke, strokeWidth = 1.2, ...props }: GraphicComponentProps) => (
  <path
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...props}
    d="M8.4,5 L8.4,2.5 C8.4,1.4 7.5,0.6 6.4,0.6 L3.8,6.3 L3.8,13.2 L11.2,13.2 C11.8,13.3 12.4,12.8 12.5,12.2 L13.4,6.5 C13.4,6.1 13.3,5.7 13.1,5.5 C12.8,5.2 12.5,5 12.1,5 L8.4,5 Z M3.8,13.2 L1.9,13.2 C1.2,13.2 0.6,12.7 0.6,12 L0.6,7.6 C0.6,6.9 1.2,6.3 1.9,6.3 L3.8,6.3"
  />
);
